import Head from "next/head";
import React from "react";

interface Props {
  src: string;
  alt: string;
  width: number;
  height: number;
  quality?: number;
  style?: React.CSSProperties;
  isMobile?: boolean;
  onLoad?: () => void;
}

export default function LCPImage({
  src,
  alt,
  width,
  height,
  style,
  isMobile = false,
  onLoad,
}: Props) {
  const imgRef = React.useRef<HTMLImageElement>(null);

  React.useEffect(() => {
    if (imgRef.current?.complete) {
      onLoad?.();
    }
  }, [onLoad]);


  // note: if the banner image change, we need reupload file to /public/image/ folder if we want to optimize image
  const isTransformasiBanner = src.includes("img-partner-transformasi-banner");
  const localBannerPath = isMobile
    ? "/image/img-partner-transformasi-banner-360.webp"
    : "/image/img-partner-transformasi-banner-486.webp";

  const resolvedSrc = isTransformasiBanner ? localBannerPath : src;

  return (
    <>
      <Head>
        <link
          key={`preload-${resolvedSrc}`}
          rel="preload"
          as="image"
          href={resolvedSrc}
          {...({
            fetchpriority: "high",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          } as any)}
        />
      </Head>

      <img
        ref={imgRef}
        src={resolvedSrc}
        alt={alt}
        width={width}
        height={height}
        decoding="async"
        loading="eager"
        onLoad={onLoad}
        {...({ fetchpriority: "high" } as React.ImgHTMLAttributes<HTMLImageElement>)}
        style={{
          width: "100%",
          maxWidth: `${width}px`,
          height: "auto",
          objectFit: "contain",
          ...style,
        }}
      />
    </>
  );
}
